import { render, staticRenderFns } from "./NormalSearchNav450.vue?vue&type=template&id=6c70cffa&scoped=true"
import script from "./NormalSearchNav450.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav450.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c70cffa",
  null
  
)

export default component.exports